import { createStyles, keyframes } from '@mantine/emotion';

const pulse = keyframes({
  '0%': { boxShadow: '0 0 0 0 rgba(18, 184, 134, 0.5)' },
  '70%': { boxShadow: '0 0 0 12px rgba(18, 184, 134, 0)' },
  '100%': { boxShadow: '0 0 0 0 rgba(18, 184, 134, 0)' },
});

export const useFabStyles = createStyles((theme) => ({
  fab: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: theme.colors.teal[6],
    color: theme.white,
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: theme.shadows.lg,
    transition: 'transform 150ms ease, box-shadow 150ms ease',

    '&:hover': {
      transform: 'scale(1.08)',
      backgroundColor: theme.colors.teal[7],
      boxShadow: theme.shadows.xl,
    },
  },
  // Member chat is a different destination, not a variant of the assistant —
  // colour carries that as much as the icon does.
  fabMember: {
    backgroundColor: theme.colors.blue[6],
    '&:hover': { backgroundColor: theme.colors.blue[7] },
  },
  pulsing: {
    animation: `${pulse} 2s infinite`,
  },
}));
